import axios from '../../../http';

function initialState () {
  return {
    name: null,
    accountName: null,
    sortCode: null,
    sortCode1: null,
    sortCode2: null,
    sortCode3: null,
    accountNumber: null,
    branch: null,
    bankAddressLine1: null,
    bankAddressLine2: null,
    bankAddressTown: null,
    bankAddressPostCode: null,
    preferredDirectDebitDay: null,
    isCertainOfDataCorrectness: false,
    isAuthorisedToSetupDirectDebits: null
  };
}

const state = initialState();

const getters = {};

const actions = {
  async update ({ state, rootState, dispatch }) {
    const { switchKey } = rootState.storage;

    try {
      const { status } = await axios({
        method: 'POST',
        url: '/request/switch/pro/update/bank',
        data: { switchKey, ...state }
      });

      if (status != 200) {
        throw 'bank';
      }
    } catch (error) {
      throw 'bank';
    }
  },
  async verifyBankDetails ({ state, rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/bank/is-valid',
        data: {
          switchKey,
          sortCode: state.sortCode,
          accountNumber: state.accountNumber
        }
      });

      if (status != 200) {
        throw 'verify bank';
      }
    } catch (error) {
      throw 'verify bank';
    }
  }
};

const mutations = {
  updateState (state, value) {
    state = Object.assign(state, value);
  },
  resetState (state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
